module.exports = __webpack_public_path__ + "img/01n.93ebea37.svg";